import { useCheckVotingOpenStateChange } from '@nv/hooks'
import { isAdmin } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { AdminEventContent } from '../../admin_event_content/AdminEventContent'
import { VoterEventContent } from '../../voter_event_content/VoterEventContent'
import DropdownBanner from '../dropdown_banner/DropdownBanner'

const EventDisplayCard = ({ title, event: propsEvent, view, onSelectEvent }: any) => {
  const { votingOpen, loadingVotingOpen } = useCheckVotingOpenStateChange({
    event: propsEvent,
    closeDate: propsEvent.closeDate,
  })

  const renderView = () => {
    if (view === 'voter')
      return <VoterEventContent loadingVotingOpen={loadingVotingOpen} event={propsEvent} title={title} votingOpen={votingOpen} />
    if (view === 'admin')
      return (
        <AdminEventContent
          loadingVotingOpen={loadingVotingOpen}
          event={propsEvent}
          title={title}
          votingOpen={votingOpen}
          onSelectEvent={onSelectEvent}
        />
      )
  }
  return renderView()
}

const EventList = ({ events = [], status, onSelectEvent }: any) => {
  const { t } = useTranslation()

  return (
    <DropdownBanner status={status} isOpenByDefault={events?.length > 0}>
      {events?.length > 0 ? (
        <>
          {events.map((event) => (
            <EventDisplayCard
              key={event.id}
              event={event}
              title={event.name}
              view={!isAdmin() ? 'voter' : 'admin'}
              onSelectEvent={onSelectEvent}
            />
          ))}
        </>
      ) : (
        <h2>{t(`events.noEvents.${status.toLowerCase()}`)}</h2>
      )}
    </DropdownBanner>
  )
}

export default EventList
